module.exports = __webpack_public_path__ + "static/media/logo_smv_autorizado.fa77330b.svg";